import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100%',
    textAlign: 'center',
    width: '100%',

    '& .locked': {
      '&-title': {
        marginBottom: theme.spacing(3),
        color: theme.palette.primary.main,

        '&-icon': {
          fontSize: theme.spacing(4),
        },
      },
      '&-description': {
        color: theme.palette.text.secondary,
        maxWidth: 600,
      },
    },
  },
}));

export default styles;
